import { NextPage } from "next"
import styles from '../styles/Loading.module.scss'
import HeaderStatic from "components/headerStatic"
import IsLoading from "containers/isLoading"

interface Props {
  children?: JSX.Element
}

const Loading: NextPage<Props> = ({ children }) => {
  return (
    <div className={`${styles.loading_container}`}>
      <div className={styles.container}>
        <HeaderStatic text={"Splash"} disableBack />
        <IsLoading />
        {
          children
        }
      </div>
    </div>
  )
}

export default Loading